<template>
    <div full-height>
        <dialog-payment ref="ref_dialogPayment"></dialog-payment>
        <dialog-logo ref="ref_dialogLogo"></dialog-logo>
        <dialog-preview-settings ref="ref_dialogPreviewSetting" :closeDialog="fn_closeDialogForm"></dialog-preview-settings>
        <dialog-toggle-options ref="ref_dialogToggleOptions"></dialog-toggle-options>
    </div>	
</template>

<script>
// const menuItem = require('../../config.js').configs.menuItem;
// import dialogPermission from '../dialogs/dialog_permission';
import dialogPayment from '../settings/payment/dialog_payment'
import dialogLogo from '../settings/business/dialogs/dialog_logo'
import dialogPreviewSettings from './dialogs/dialog_preview_settings'
import dialogToggleOptions from './dialogs/dialog_toggle_options'

    export default{
        components:{
        //   'dialog-permission': dialogPermission,
            'dialog-payment':dialogPayment,
            'dialog-logo':dialogLogo,
            'dialog-preview-settings':dialogPreviewSettings,
            'dialog-toggle-options':dialogToggleOptions
        },
        data(){
            return{
                data:null,
                // data:{"businessLogo":null,"paymentDetails":null,"templateSettings":{"printTemplateFields":[{"additionalData":null,"fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1","fieldType":"text","name":"PO No.","orderNumber":1,"printTemplateFieldId":"e69f3f1c-7179-4cb9-9132-3d5724fe6100","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"86723266-62de-4aac-9511-89743e6b4b7a","fieldType":"dateTime","name":"PO Date","orderNumber":2,"printTemplateFieldId":"534a94fb-7935-4bd1-a3ab-3c46f2c0158e","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2","fieldType":"choice","name":"Mode","orderNumber":3,"printTemplateFieldId":"6ab5937c-f66f-46b1-a229-4ef09c7ae8c2","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"2fd5218f-3060-60ea-177c-d5f36d6f2233","fieldType":"accountItem","name":"Transporter Name","orderNumber":4,"printTemplateFieldId":"41b4fc33-6bef-4f87-b28b-2ec8bb346fb7","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"b549972a-6a89-cf47-c33d-570b20422b87","fieldType":"text","name":"LR/CR/RR No.","orderNumber":5,"printTemplateFieldId":"82fabd7c-dcd2-444d-ba6d-85f901469441","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"},{"additionalData":null,"fieldId":"f64f89cd-4fa4-c201-f305-f0b367630a0f","fieldType":"text","name":"Vehicle No.","orderNumber":6,"printTemplateFieldId":"8f7e6354-d08f-4e64-8351-13d3a028e52f","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf"}],"printTemplateSections":[{"addData":"{\"content\":\"\u003cp\u003e\u003cstrong class\u003d\\\"ql-size-large\\\"\u003e{{BusinessName}}\u003c/strong\u003e\u003c/p\u003e\u003cp\u003e{{BusinessAddress}}\u003c/p\u003e\u003cp\u003e{{BusinessState}}\u003c/p\u003e\"}","fieldId":"715e3806-1820-481e-929d-274839ec0c28","fieldName":"Header","printSectionId":"bd39d878-40c9-465c-a4d9-27cd2bb6917e","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"header"},{"addData":"{\"content\":\"\u003cp\u003e\u003cstrong\u003eNotes:\u003c/strong\u003e\u003c/p\u003e\u003cp\u003e1. Goods once sold will not be taken back.\u003c/p\u003e\u003cp\u003e2. Payment to be made by A/c payee Cheque/DD/RTGS/NEFT/IMPS in fovour of \\\" {{BusinessName}}\\\"\u003c/p\u003e\u003cp\u003e3. All dispute are subject to {{BusinessState}} Jurisdiction.\u003c/p\u003e\u003cp\u003e4. Certified that the particulars given above are true and correct.\u003c/p\u003e\"}","fieldId":"92a6d9f7-f918-416a-b3d0-243f9e75d7da","fieldName":"Terms \u0026 Condition","printSectionId":"3bd6a058-df3f-41e5-9547-c6a497f1243c","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"terms"},{"addData":null,"fieldId":"700d9a86-6c2e-41c8-805c-71fa7612d1c5","fieldName":"Bank Details","printSectionId":"5059b9ed-a1d4-4761-a29c-aa90604f0105","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"bankDetails"},{"addData":"{\"content\":\"\u003cp\u003eFor {{BusinessName}}\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e\u003cp\u003e_____________________________\u003c/p\u003e\u003cp\u003eAuthorised Signatory\u003c/p\u003e\"}","fieldId":"d60e4514-3ee2-42de-9b8a-2d9ea7c0716a","fieldName":"Authorised Signatory","printSectionId":"9a824796-9adb-458d-af12-6858af9afb05","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"signature"},{"addData":"{\"content\":null}","fieldId":"5b9dcbb4-697f-4115-ac86-79c3cb064617","fieldName":"Bill of Supply Subtitle","printSectionId":"1582ba53-fa91-4ce2-822a-55874d860d2c","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","sectionName":"subtitle"}],"billingLabel":"Details of Receiver (Billed to)","businessLogo":true,"isHidden":false,"name":"PO No.","printTemplateId":"05d9b396-1e27-4717-8222-45354e61d2cf","shippingLabel":"Details of Consigee (Shipped to)","templateType":0,"terms":null,"theme":"theme_light"},"transactionDetails":{"invoiceTitle":"Invoice","notes":"Being Invoice Created.","otherDetails":{"transactionFields":[{"accountLedgerId":null,"fieldDataType":"text","fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1","fieldName":"PO No.","fieldValue":"123","listItemId":null,"orderNumber":"1","sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","transactionFieldId":"cb4c112d-f141-4c13-9934-b5a36f349c69","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"6db69a15-4958-4250-99ed-951f37e154de"},{"accountLedgerId":null,"fieldDataType":"dateTime","fieldId":"86723266-62de-4aac-9511-89743e6b4b7a","fieldName":"PO Date","fieldValue":"2020-05-16T00:00:00.000Z","listItemId":null,"orderNumber":"2","sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","transactionFieldId":"24d219be-e198-492c-8cd6-d24b34167c45","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"994082d6-4a13-47a3-9e35-86693aa18138"},{"accountLedgerId":null,"fieldDataType":"choice","fieldId":"452bc92a-fcdc-15ec-4cf7-a1ed93b2c4e2","fieldName":"Mode","fieldValue":"Road","listItemId":null,"orderNumber":"1","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"fa34f1b5-190f-4fc8-8b47-493cc96266b8","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"238e1c58-f7e2-14b2-9d1a-7ee40074dd6f"},{"accountLedgerId":"294664a7-623b-42c4-a506-3190f12f46f3","fieldDataType":"accountItem","fieldId":"2fd5218f-3060-60ea-177c-d5f36d6f2233","fieldName":"Transporter Name","fieldValue":"Ac Ahmed","listItemId":null,"orderNumber":"2","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"3d332c5d-9055-45c3-9445-e52f13362e8e","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"13513e10-ad45-5024-8f26-cfdc0d59a302"},{"accountLedgerId":null,"fieldDataType":"text","fieldId":"b549972a-6a89-cf47-c33d-570b20422b87","fieldName":"LR/CR/RR No.","fieldValue":"Qwe","listItemId":null,"orderNumber":"3","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"3acd7b90-1449-4779-ae3f-3c9a287dc600","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"d000e4fa-0ae0-da3d-849f-999601b80b92"},{"accountLedgerId":null,"fieldDataType":"text","fieldId":"f64f89cd-4fa4-c201-f305-f0b367630a0f","fieldName":"Vehicle No.","fieldValue":"5018","listItemId":null,"orderNumber":"4","sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","transactionFieldId":"05246ed9-db7c-4508-af3a-3c4d39afb197","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionTypeFieldId":"5d0899a5-cfc0-b337-affb-ccea5573221e"}],"transactionSections":[{"orderNumber":1,"sectionId":"63008be4-4042-482a-b00a-7b823a1c4d18","sectionName":"Other Details","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionSectionId":"524f2a08-0a14-4cf1-a04f-c473df354099"},{"orderNumber":2,"sectionId":"22d09bdd-1907-f313-0b27-61ac7ac48c14","sectionName":"Transporter Details","transactionId":"87630360-b68d-47c1-a278-d6d296c2bb19","transactionSectionId":"d0511e9c-2b03-4f85-b9af-5fcba1386195"}]},"partyDetails":{"address":[],"gstNumber":"ABCDEABCDEABCDE","partyName":"Abinav","placeOfSupply":"Delhi","printDetails":"{\"printName\":\"Abinav\"}"},"roundedAmount":5000.0,"taxableValue":5000.0,"transactionAddOns":[],"transactionDate":"2020-05-16T15:05:49.616Z","transactionItems":[{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":5,"value":500},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":200.0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":200.0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null},{"baseTransactionListId":"10003","baseTransactionNumber":"TI001","cols":{"addOns":[{"addOnsId":"a5f79de4-f097-2ad5-1ad7-f20fd24972bd","isGst":true,"name":"CGST","percentage":0.0,"value":0.0},{"addOnsId":"04a59876-ce17-0924-ea85-b956b46a505d","isGst":true,"name":"SGST","percentage":0.0,"value":0.0}],"baseTransactionNumber":"TI001","hsn":null,"itemName":"P1","mrp":0.0,"netAmount":5000.0,"qty":25.0,"rate":0,"taxableValue":5000.0,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pieces"},"description":null}],"transactionNumber":"TI001","transactionTds":[]}},
                billingAddress:null,
                partyPhoneBilling:null,
                partyPhoneShipping:null,
                shippingAddress:null,
                otherFields:[],
                // showOtherFields:false,
                headers:[],
                items:[],
                summary:{"totalTax":0},
                addOnsTotal:[],
                gstAddOnsTotal:[],
                netTotal:0,
                isHsn:false,
                isMrp:false,
                header:{data:null, fieldId:null},
                terms:{data:null, field:null},
                printNote:{data:null, field:null},
                bankDetails:{data:null, field:null},
                signatory:{data:null, field:null},
                subtitle:{data:null, field:null},
                // printDetails:null,
                isRef:false,
                colors:["rgba(75,119,190,0.4)", "rgba(211,211,211,0.4)", "rgba(128,128,128,0.4)", "#fff", "rgba(0,128,128,0.4)", "rgba(173,216,230,0.4)", "rgba(144,238,144,0.4)", "rgba(135,206,250,0.4)", "rgba(255,182,193,0.4)"],
                themeColor:null,
                previewTemplate:null,
                printTemplate:null,
                templateNo:1,
                templates:[1, 2, 3, 4, 5],
                backButtonPress:false,
                hasItems:false,
                zoomPercent:"100%",
                invoiceLoaded:false,

                description:{showInPrintOut:true},
				itemDescription:{showInPrintOut:true},
				brand:{showInPrintOut:false},
				category:{showInPrintOut:false},
				company:{showInPrintOut:false},
                gridClass:0
            }
        },
        methods:{

            fn_openToggleOptions: function(descriptionObj, itemDescriptionObj, brandObj, categoryObj, companyObj){
				this.description.showInPrintOut = descriptionObj.showInPrintOut;
				this.itemDescription.showInPrintOut = itemDescriptionObj.showInPrintOut;
				this.brand.showInPrintOut = brandObj.showInPrintOut;
				this.category.showInPrintOut = categoryObj.showInPrintOut;
				this.company.showInPrintOut = companyObj.showInPrintOut;
				this.$refs['ref_dialogToggleOptions'].openDialogWeb();
			},

			fn_toggleItemDetails: function(key, val){
				let dataObj = {};
				dataObj.LocalKey = key;
				dataObj.LocalValue = val;
				this.$root.fn_saveLocalData(dataObj);

				if(key == 'item_description' && this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].description){
					this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].description.showInPrintOut = val;
				}
				else if(key == 'item_itemDescription' && this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].itemDescription){
					this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].itemDescription.showInPrintOut = val;
				}
				else if(key == 'item_category' && this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].category){
					this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].category.showInPrintOut = val;
				}
				else if(key == 'item_brand' && this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].brand){
					this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].brand.showInPrintOut = val;
				}
				else if(key == 'item_company' && this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].company){
					this.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].company.showInPrintOut = val;
				}
			},

            fn_closeDialogForm: function(){
                this.$refs['ref_dialogPreviewSetting'].closeDialogWeb();
                // localStorage.setItem('from_preview_settings', 1);
                this.fn_goBack();
            },

            fn_openDialogBusinessLogo: function(){
                this.$refs['ref_dialogLogo'].openDialogWeb();
            },

            fn_openDialogUpi: function(){
                this.$refs['ref_dialogPayment'] ? this.$refs['ref_dialogPayment'].openDialogWeb() : '';
            },

            fn_changeColor: function(color){
                // this.printTemplate = null;
                this.themeColor = color;
            },

            fn_resetDefault: function(){
                this.templateNo = 1;
                this.themeColor = "rgba(75,119,190,0.4)";
                this.fn_saveTemplateSettings('default');
            },

            fn_saveTemplateSettings: function(settingsType){
                var self = this;
                let dataObj = {};
                dataObj.printTemplateId = this.templateNo == 101 ?  this.data.templateSettings.printTemplateId : this.data.transactionDetails.printTemplateId;
                dataObj.themeColor = this.themeColor;
                dataObj.invoiceTemplate = this.templateNo;
                dataObj.visibilityConfig = this.data.templateSettings.visibilityConfig ? this.data.templateSettings.visibilityConfig : null;
                this.postData('UpdatePrintTemplate', dataObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(settingsType == "default"){
                                self.$eventHub.$emit('snackbarAlert', {msg:'Settings updated to default'});
                            }
                            else{
                                self.$eventHub.$emit('snackbarAlert', {msg:'Settings updated'});
                            }
                            //   self.fn_goBack();
                            self.fn_closeDialogForm();
                        },
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_calculateZoomPercent: function(headerWidth){
                // let bodyTableElement = document.getElementById("body_template_"+this.templateNo);
                // let percentage = ((window.outerWidth - 32) / bodyTableElement.offsetWidth) * 100;
                // let headerTableElement = document.getElementById("header_template_"+this.templateNo);
                // let elementWidth = Number(headerTableElement.style.minWidth.replace("px", ''));

                let elementWidth = Number(headerWidth.replace("px", ''));
                let percentage = ((window.outerWidth - 32) / elementWidth) * 100;
                console.log(percentage);
                this.zoomPercent = percentage + '%';

                let self = this;
                setTimeout(function(){
                    self.invoiceLoaded = true;
                },300);
            },

            fn_bindInvoiceTemplate: function(templateNo){
                // this.printTemplate = null;

                // if(!templateNo && localStorage.getItem("template_settings")){
                // 	let settings = JSON.parse(localStorage.getItem("template_settings"));
                // 	this.templateNo = settings.templateNo;
                // 	this.themeColor = settings.themeColor;
                // }
                // else{
                // 	this.templateNo = templateNo ? templateNo : this.$route.query.template_no;	
                // 	this.fn_saveTemplateSettingsToLocal();
                // }

                // this.templateNo = templateNo ? templateNo : this.$route.query.template_no;

                // this.printTemplate = require('./invoices/template'+this.templateNo).default;
                console.log(this.previewTemplate);
                if(!templateNo){
                    this.fn_getInvoiceData();
                }
                else{
                    this.templateNo = templateNo;
                    this.previewTemplate = require('./invoices/template'+templateNo).default;
                    let self = this;
                    setTimeout(function(){
                        self.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].fn_init(self.templateNo);
                    },300);
                }
            },

            // fn_saveTemplateSettingsToLocal: function(){
            // 	let obj = {};
            // 	obj.themeColor = this.themeColor;
            // 	obj.templateNo = this.templateNo;
            // 	localStorage.setItem("template_settings", JSON.stringify(obj));
            // },

            fn_getInvoiceData: function(){
                var self = this;
                let fName = null;
                if(this.$route.query.printtype){
                    fName = this.$route.query.printtype == 'ab' ? "AccountBookPrintData" : "StockJournalPrintData";
                }
                else{
                    fName = "InvoiceData"
                }

                this.getData(fName, this.$route.query.tId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.data = JSON.parse(response);

                            if(localStorage.getItem("template_settings")){
                                let dataObj = JSON.parse(localStorage.getItem("template_settings"));
                                self.templateNo = dataObj.templateNo;
                                self.themeColor = dataObj.themeColor;
                            }
                            else{
                                self.templateNo = self.data.templateSettings.invoiceTemplate;
                                self.themeColor = self.data.templateSettings.themeColor;	
                            }

                            if(self.templateNo == 101){
                                self.invoiceLoaded = true;

                                // sorting as per amount types
                                self.data.transactionLedgers.sort(function(a, b){
                                    return b.amountType - a.amountType;
                                });
                                // sorting transaction ledgers as per order number
                                self.data.transactionLedgers.sort(function(a, b){
                                    return a.orderNumber - b.orderNumber;
                                });
                            }
                            else{
                                if(self.data.transactionDetails.transactionListId == 10005){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.estimatePrintTitle ? self.$root.TransactionSettings.estimatePrintTitle : 'Estimate';
								}
                                else if(self.data.transactionDetails.transactionListId == 10004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.saleReturnPrintTitle ? self.$root.TransactionSettings.saleReturnPrintTitle : 'Sale Return';
								}
								else if(self.data.transactionDetails.transactionListId == 20004){
									self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.purchaseReturnPrintTitle ? self.$root.TransactionSettings.purchaseReturnPrintTitle : 'Purchase Return';
								}
                                else if(self.data.transactionDetails.transactionListId == 10003 && self.$root.CurrentBusiness.GSTRegistrationStatus != 1){
									if(self.$root.TransactionSettings.invoicePrintTitle && self.$root.TransactionSettings.invoicePrintTitle != 'Default'){
										self.data.transactionDetails.invoiceTitle = self.$root.TransactionSettings.invoicePrintTitle;
									}
								}
                            }

                            if(self.data.transactionDetails && self.data.transactionDetails.transactionItems && self.data.transactionDetails.transactionItems.length){
                                // self.fn_removeZeroTaxAddons();
                                self.hasItems = true;
                            }
                            else{
                                self.hasItems = false;
                            }

                            self.previewTemplate = require('./invoices/template'+self.templateNo).default;
                            // if(!localStorage.getItem("template_settings")){
                            // 	self.themeColor = self.data.templateSettings.themeColor;
                            // 	self.$forceUpdate();
                            // 	self.fn_saveTemplateSettingsToLocal();
                            // }
                            setTimeout(function(){
                                self.$refs['ref_dialogPreviewSetting'].$refs['ref_previewTemplate'].fn_init(self.templateNo, self.fn_calculateZoomPercent);
                                self.invoiceLoaded = true;
                            },300);

                            self.$root.fn_getLocalItem('invoiceGridClassValue', response=>{
								let data = JSON.parse(response);
								if(data && data.LocalValue){
									self.gridClass = data.LocalValue;
								}
							});
                        }, 
                        onError: function(error){
                            console.log(error);           
                        }
                    }
                );
            },

            fn_removeZeroTaxAddons: function(){
                for(let i=0; i<this.data.transactionDetails.transactionItems.length; i++){
                    let item = this.data.transactionDetails.transactionItems[i];
                    item.cols.addOns = item.cols.addOns.filter(addOnsItem => {
                        // return addOnsItem.isGst && addOnsItem.percentage != 0;
                        return addOnsItem.percentage != 0;
                    })
                }
            },

            fn_shareInvoice: function(type){
                let shareObj = {};
                shareObj.type = 'pdf';
                shareObj.primaryMobileNumber = this.data.transactionDetails.partyDetails.primaryMobileNumber && type == 'sharewhatsapp' ? this.data.transactionDetails.partyDetails.primaryMobileNumber : null;
                shareObj.subject = "Invoice Details";
                shareObj.email = this.data.transactionDetails.partyDetails.email ? [this.data.transactionDetails.partyDetails.email] : null ;
                shareObj.textMessage = "Dear "+this.data.transactionDetails.partyDetails.partyName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(this.data.transactionDetails.transactionDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(this.data.transactionDetails.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
                this.fn_exportToPdf(shareObj);
                // this.fn_getPrintData('InvoiceData', this.displayData.transactionId, 'pdf', shareObj);
            },

            // fn_initPrintTemplate: function(type){
            // 	this.showLoading('Please wait...');
            // 	this.printTemplate = require('./invoices/template'+this.templateNo).default;
            // 	// this.$refs['ref_printTemplate'].fn_init();
            // 	let self = this;

            // 	setTimeout(function(){
            // 		self.$refs['ref_printTemplate'].fn_init();
            // 	},1000);

            // 	setTimeout(function(){
            // 		self.hideLoading();
            // 		if(type=='print'){
            // 			self.fn_printInvoice();
            // 		}
            // 		else{
         //                self.$root.fn_checkStoragePermission(function(){
         //                    // self.showLoading('Please wait...');
         //                    // self.fn_allowPrintData(name, transactionId, type, shareObj);
         //                    if(type=='sharewhatsapp'){
            // 					self.fn_shareInvoice('sharewhatsapp');
            // 				}
            // 				else{
            // 					self.fn_exportToPdf(null);
            // 				}
         //                })
            // 		}
            // 		// else if(type=='sharewhatsapp'){
            // 		// 	self.fn_shareInvoice('sharewhatsapp');
            // 		// }
            // 		// else{
            // 		// 	self.fn_exportToPdf(null);
            // 		// }
            // 	},2000);
            // },

            fn_printInvoice: function(){
                // let fileName = 'print_' + this.data.transactionDetails.transactionNumber + '_' + this.data.transactionDetails.transactionDate;

                let transactionTypeFormName = null;
                if(this.data.transactionDetails && this.data.transactionDetails.transactionTypeFormName){
                    transactionTypeFormName = this.data.transactionDetails.transactionTypeFormName;
                }
                else{
                    transactionTypeFormName = this.data.invoiceTitle;
                }

                if(this.data.transactionDetails && this.data.transactionDetails.invoiceTitle == 'Tax Invoice'){
                    transactionTypeFormName = "Invoice";
                }
                
                let fileName = transactionTypeFormName.replace(/ /g,'') + '-' + this.data.transactionDetails.transactionNumber + '_' + this.$root.fn_getCurrentDateTimeString();
                console.log(fileName);
                // AndroidRoutingTest.print(fileName);
                window.print();
       //          let self = this;
       //          setTimeout(function(){
                // 	self.printTemplate = null;
                // },5000);
            },

            fn_exportToPdf: function(shareObj){
                let self = this;

                let transactionTypeFormName = null;
                if(this.data.transactionDetails && this.data.transactionDetails.transactionTypeFormName){
                    transactionTypeFormName = this.data.transactionDetails.transactionTypeFormName;
                }
                else{
                    transactionTypeFormName = this.data.invoiceTitle;
                }

                if(this.data.transactionDetails && this.data.transactionDetails.invoiceTitle == 'Tax Invoice'){
                    transactionTypeFormName = "Invoice";
                }
                
                let fileName = transactionTypeFormName.replace(/ /g,'') + '-' + this.data.transactionDetails.transactionNumber + '_' + this.$root.fn_getCurrentDateTimeString();
                
                this.exportToPdf(fileName+'.pdf',{

                  onSuccess: function(response){
                        console.log(response);
                        if(shareObj != undefined)
                            self.$root.fn_share(shareObj);
                        else
                            self.$eventHub.$emit('snackbarAlert', {msg:transactionTypeFormName + ' downloaded'});
                            // alert('Invoice downloaded');

         //                setTimeout(function(){
                        // 	self.printTemplate = null;
                        // },5000);
                  }, 
                  onError: function(error){
                        console.log(error);
                    //   alert('Invoice download failed');
                        this.$eventHub.$emit('snackbarAlert', {msg:transactionTypeFormName + ' downloaded failed'});
                  }
                });
            },

            fn_editPartyDetails: function(){
                // this.$router.push({path:"/masters/accounts/ledgers/items/"+this.data.transactionDetails.partyDetails.partyId+"/edit"});
                this.$router.push('/'+this.$route.params.businessId+'/'+this.$route.params.listId+'/ledger/items/'+this.data.transactionDetails.partyDetails.partyId+'/edit');
            },

            fn_editBusinessProfile: function(){
                // this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
                this.$router.push({path:'/'+ this.$root.CurrentBusiness.BusinessID + '/' + this.$route.params.listId + '/business/profile/edit'});
            },

            fn_editBusinessLogo: function(){
                this.$router.push({path:"/settings/logo/upload", query:{preview_template:1}});
            },

            fn_editTransactionFields: function(){
                switch (Number(this.$route.query.listId)) {
                    case 10001:
                    case 10002:
                    case 10003:
                    case 10004:
                    case 10005:
                        this.$router.push({path:"/transactions/sales/"+this.$route.query.title+"/items/"+this.$route.query.tId+"/edit", query:{scroll_field:"custom_fields"}});
                        break;
                    case 20001:
                    case 20002:
                    case 20003:
                    case 20004:
                    case 20005:
                        this.$router.push("/transactions/purchase/"+this.$route.query.title+"/items/"+this.$route.query.tId+"/edit");
                        break;
                    default:
                        console.log("condition not matched");
                }
            },

            fn_editPrintField: function (fieldId, type) {
                if(type=="signature"){
                    // this.$router.push({path:"/printfield/items/"+fieldId+"/edit", query:{disableName: true, signature:1}});	
                    this.$router.push({path:"/" + this.$root.CurrentBusiness.BusinessID + "/" + this.$route.params.listId + "/printfields/items/" + fieldId + "/edit", query:{signature:1}});
                }
                else{
                    // this.$router.push({path:"/printfield/items/"+fieldId+"/edit", query:{disableName: true, dialog:1}});	
                    this.$router.push({path:"/" + this.$root.CurrentBusiness.BusinessID + "/" + this.$route.params.listId + "/printfields/items/" + fieldId + "/edit"});
                }
            },

            // fn_getBottomMenu: function () {

            //     var bottomMenu = {"BottomMenu": [menuItem.reset, menuItem.share]};
            //     let tagId = 'preview'
            //     this.setBottomMenu(tagId, bottomMenu, 
            //         {
            //             onSuccess: function (response) {
            //                 console.log(response);
            //             },
            //             onError: function (error) {
            //                 console.log(error);
            //             }
            //         }
            //     )
            // },

            // fn_menuItemClick: function(tagId, menuId, menuAction){
            //     // tagId id form future use
            //     // menuId id form future use
            //     if(menuAction=='reset'){
            //         this.fn_reset();
            //     }
            //     else if(menuAction=='share'){
            //         this.fn_shareInvoice('share');
            //     }
            //     else if(menuAction=='help'){
            //         this.$router.push("/settings");
            //     }
            // },

            // fn_reset: function(){
            // 	localStorage.removeItem("template_settings");
            // 	this.themeColor = this.data.templateSettings.themeColor;
            // 	this.fn_bindInvoiceTemplate();
            // },

            // fn_openPermissionDialog: function(permissionType){
            //     this.$root.permissionType = permissionType;
            //     this.$refs['ref_dialogPermission'].dialog_permission = true;
            // },

            fn_closeDialog: function(){
                this.$refs['ref_dialogPermission'].dialog_permission = false;
            },

            fn_goBack: function(){
                this.backButtonPress = true;
                this.$router.go(-1);
            }
        },
        mounted(){
            // window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
            // window.js_globals.fn_onBackPress = this.fn_goBack;
            this.$refs['ref_dialogPreviewSetting'].openDialogWeb();
            this.fn_bindInvoiceTemplate();

            this.$eventHub.$on('upidetails', () => {
                this.fn_openDialogUpi();
            });
        },
        beforeRouteLeave(to, from, next){
            if(this.backButtonPress){
                localStorage.removeItem("template_settings");
                next();
            }
            else{
                let obj = {};
                obj.themeColor = this.themeColor;
                obj.templateNo = this.templateNo;
                localStorage.setItem("template_settings", JSON.stringify(obj));
                next();
            }
        },
        beforeRouteEnter(to, from, next){
              next(vm => {
                  if(from.name == 'invoicePreview'){
                      console.log(vm);
                      localStorage.removeItem("template_settings");
                  }
              });
        },
        // computed:{
        // 	filteredItems: function(){
        // 		let transactionGroups = [];

        // 		for(let i in this.items){

        // 			if(this.items[i].baseTransactionNumber != this.data.transactionDetails.transactionNumber){
        // 				this.isRef = true;
        // 			}

        // 	        let itemIndex = transactionGroups.findIndex(transItem => transItem.baseTransactionNumber==this.items[i].baseTransactionNumber);

        // 	        if(itemIndex!=-1){
        // 	            transactionGroups[itemIndex].items.push(this.items[i]);
        // 	        }
        // 	        else{
        // 	            let obj = {};
        // 	            obj.baseTransactionNumber = this.items[i].baseTransactionNumber;
        // 	            obj.items = []
        // 	            obj.items.push(this.items[i]);
        // 	            transactionGroups.push(obj);
        // 	        }
        // 	    }

        // 	    console.log(JSON.stringify(transactionGroups));

        // 	    return transactionGroups;
        // 	}
        // }
    }
</script>